var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasNoStationData
        ? _c(
            "div",
            { staticClass: "pa-4 text-xs-center" },
            [
              _c("v-icon", [_vm._v("warning")]),
              _vm._v(" "),
              _c("br"),
              _vm._v("\n    No matching stations found\n  "),
            ],
            1
          )
        : _c(
            "v-list",
            { staticClass: "pa-0 mx-0", attrs: { dense: "" } },
            [
              _vm.filterToggle == _vm.filterToggles.selected &&
              _vm.selectionCount == 0
                ? _c(
                    "div",
                    { staticClass: "pa-4 text-xs-center" },
                    [
                      _c("v-icon", { attrs: { color: "warning" } }, [
                        _vm._v("warning"),
                      ]),
                      _c("br"),
                      _vm._v("\n      No stations selected\n    "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "VirtualList",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(
                        _vm.filterToggle == _vm.filterToggles.selected &&
                        _vm.selectionCount == 0
                      ),
                      expression:
                        "!(filterToggle == filterToggles.selected && selectionCount == 0)",
                    },
                  ],
                  ref: "virtualScroll",
                  attrs: { size: 40, remain: 6 },
                },
                [
                  _vm._l(_vm.timeSeriesStations, function (item, index) {
                    return [
                      [
                        _c(
                          "v-list-tile",
                          {
                            key: `item-${index}`,
                            on: {
                              click: function ($event) {
                                return _vm.toggleStation(item.Id)
                              },
                            },
                          },
                          [
                            _c("v-list-tile-avatar", {
                              staticStyle: { "min-width": "0px" },
                            }),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-action",
                              { staticStyle: { "min-width": "0px" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    disabled: _vm.disabled,
                                    primary: "",
                                    color: "primary",
                                    "input-value": _vm.getStationValue(item),
                                    "hide-details": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c(
                                  "v-list-tile-title",
                                  { staticClass: "font-weight-thin" },
                                  [
                                    _vm._v(
                                      _vm._s(item.Identifier) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }